import util from '../util'

let controller = 'v1/PermissaoLiberacaoEspecial'

export default Object.assign({}, util.GetCrud(controller, null), {
    Listar: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller + "/listar", dto)
    }
})